import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from '@services/confirmation';

export interface PageHasChanges {
  hasPendingChanges(): boolean;
  discardChanges?(): void;
}

export const pageHasChangesGuard: CanDeactivateFn<PageHasChanges> = async (component: PageHasChanges): Promise<boolean> => {
  if (!component.hasPendingChanges()) return true;

  const confirmationService = inject(ConfirmationService);
  const translate = inject(TranslateService);

  const confirmed = await confirmationService.confirm({
    title: translate.instant('validations.pendingChanges.title'),
    message: translate.instant('validations.pendingChanges.message')
  });

  if (confirmed) component.discardChanges?.();

  return confirmed;
};
